/**
 * This function is helpers to audio descriptions for reduces repeat code
 * @param {Callback} cancel 
 * @param {Callback} speak 
 * @param {String} text 
 * @param {String} lang 
 * @param {Boolean} condition 
 */
export const audioDescription = (cancel, speak, text, lang, condition) => {
    if(!condition) return;

    cancel(); 
    speak({ 
        text: text, 
        voice: window.speechSynthesis.getVoices().filter(ele => ele.lang === lang)[0]
    })
}